<template>
  <div
    ref="chartDom"
    v-loading="loading"
    style="height: 100%; min-height: 320px"
  />
</template>
  
<script>
let echarts = require("echarts");
let elementResizeDetectorMaker = require("element-resize-detector");
export default {
  props: {
    params: { type: Object },
  },
  data() {
    return {
      loading: false,
      source: null,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$apis.job.schedule.statis
        .type({
          ...this.params,
          state: 9,
        })
        .then((res) => {
          let option = {
            title: {
              text: "跟进工作情况",
              left: "center",
              bottom: 0,
            },
            tooltip: {
              trigger: "item",
              formatter: "{b} : {c}次",
            },
            xAxis: {
              type: "category",
              data: res.map((x) => {
                return this.$utils.meta.format("schedule-type", x.text);
              }),
            },
            yAxis: {
              type: "value",
            },
            series: [
              {
                data: res.map((x) => {
                  return {
                    name: this.$utils.meta.format("schedule-type", x.text),
                    value: x.value,
                  };
                }),
                type: "bar",
                label: {
                  show: true,
                  position: "top",
                },
                showBackground: true,
                backgroundStyle: {
                  color: "rgba(180, 180, 180, 0.2)",
                },
              },
            ],
          };
          const chart = this.$refs["chartDom"];
          if (chart) {
            let myChart = echarts.init(chart);
            myChart.setOption(option);
            //刷新响应
            elementResizeDetectorMaker().listenTo(chart, function () {
              myChart.resize();
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
ul.list {
  li {
    line-height: 30px;
    span {
      min-width: 100px;
      display: inline-block;
    }
    span + span {
      margin-left: 10px;
    }
    :first-child {
      font-weight: bold;
    }
  }
  li + li {
    margin-top: 10px;
  }
}
</style>